module.exports = __webpack_public_path__ + "static/media/banner_svg.d4839c78.svg";